'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _aum = require('./aum.js');

var _aum2 = _interopRequireDefault(_aum);

var _expenses = require('./expenses.js');

var _expenses2 = _interopRequireDefault(_expenses);

var _nav = require('./nav.js');

var _nav2 = _interopRequireDefault(_nav);

var _sec_yield = require('./sec_yield.js');

var _sec_yield2 = _interopRequireDefault(_sec_yield);

var _weekly_liquid_asset = require('./weekly_liquid_asset.js');

var _weekly_liquid_asset2 = _interopRequireDefault(_weekly_liquid_asset);

var _ytd_percentage_us = require('./ytd_percentage_us.js');

var _ytd_percentage_us2 = _interopRequireDefault(_ytd_percentage_us);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _quick_stat = require('./quick_stat');

var _quick_stat2 = _interopRequireDefault(_quick_stat);

var _number_utility = require('../../../packages/common-utilities/src/number_utility.js');

var _number_utility2 = _interopRequireDefault(_number_utility);

var _currency_utility = require('../../../packages/common-utilities/src/currency_utility.js');

var _currency_utility2 = _interopRequireDefault(_currency_utility);

var _ramda = require('ramda');

var _formatted_number = require('./global_components/formatted_number');

var _formatted_number2 = _interopRequireDefault(_formatted_number);

var _fund_utility = require('../../../packages/common-utilities/src/fund_utility');

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _collection_utility = require('common-utilities/src/collection_utility');

var _number_utility3 = require('common-utilities/src/number_utility');

var _yield_to_maturity_worst = require('./yield_to_maturity_worst');

var _yield_to_maturity_worst2 = _interopRequireDefault(_yield_to_maturity_worst);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HeaderStats = function (_React$Component) {
  _inherits(HeaderStats, _React$Component);

  function HeaderStats(props) {
    _classCallCheck(this, HeaderStats);

    var _this = _possibleConstructorReturn(this, (HeaderStats.__proto__ || Object.getPrototypeOf(HeaderStats)).call(this, props));

    _this.renderSinceInceptionReturnAtNav = function (sinceInceptionReturn, bootstrapColumns, isMoneyMarketFund) {
      return !(0, _functional_utility.isNilOrEmpty)(sinceInceptionReturn) && _collection_utility.CollectionUtility.includes(_this.props.visibleDataPoints, 'QUICK_STAT_SINCE_INCEPTION_RETURN_AT_NAV') && _react2.default.createElement(
        'div',
        {
          className: 'col-xs-7 col-sm-6 ' + bootstrapColumns + ' margin-horizontal-0 ' + (0, _functional_utility.ifMobileBreakpoint)(_this.props.breakpoint, "padding-top-15", "padding-top-30 left-border") + ' ' + (_this.props.breakpoint === 3 && !isMoneyMarketFund ? "margin-bottom-25" : "") },
        _react2.default.createElement(_ytd_percentage_us2.default, {
          title: _string_utility2.default.renderFormattedLabel("Since Inception Return – at NAV", "pdp-fund-stats-since-inception-return-label-at-nav"),
          ytdPercentage: sinceInceptionReturn.annualizedNoLoadReturnPercentage,
          ytdDate: sinceInceptionReturn.performanceReturnEffectiveDate,
          salesChargeAdjustedYtdPercentage: sinceInceptionReturn.cumulativeNoLoadPercentage,
          atNavLabelKey: 'label-for-at-nav-annualized',
          atNavWithSalesChargeLabelKey: 'label-for-at-nav-with-sales-charge-cumulative',
          fundTypeCode: _this.props.fund.fundTypeCode,
          breakpoint: _this.props.breakpoint,
          tooltip: _this.props.tooltip,
          country: _this.props.country,
          role: _this.props.role,
          intl: _this.props.intl
        })
      );
    };

    _this.renderDailyYield = function () {
      var shouldShow = _collection_utility.CollectionUtility.includes(_this.props.visibleDataPoints, 'QUICK_STAT_DAILY_YIELD');
      if (!shouldShow) {
        return null;
      }
      var formattedValue = _number_utility2.default.formatToPercentWith2FixedDecimalsAfterMultiplyingBy100(_this.props.fund.shareClass.dailyYield.oneDayCurrentYield);
      return _this.renderQuickStat(_string_utility2.default.renderFormattedLabel('DAILY YIELD', "pdp-quick-stat-daily-yield"), _this.props.fund.shareClass.dailyYield.effectiveDate, formattedValue, 'quick-stat-daily-yield', true, 'QUICK_STAT_DAILY_YIELD', null, '', true, formattedValue === '-', shouldShow);
    };

    _this.renderTaxableEquivalentYield = function () {
      return _this.renderQuickStat(_string_utility2.default.renderFormattedLabel('TAXABLE EQUIVALENT YIELD', "pdp-quick-stat-taxable-equivalent-yield"), _this.props.fund.shareClass.secYield.effectiveDate, _number_utility2.default.formatToPercentWith2FixedDecimalsAfterMultiplyingBy100(_this.props.fund.shareClass.secYield.taxEquivalentYield), 'quick-stat-taxable-equivalent-yield', true, 'QUICK_STAT_TAXABLE_EQUIVALENT_YIELD', 'pdpDataPointTaxEquivalentYield', '', true);
    };

    return _this;
  }

  _createClass(HeaderStats, [{
    key: 'renderYtdPercentageUS',
    value: function renderYtdPercentageUS(bootstrapColumns, isMoneyMarketFund) {
      if (this.props.fund.shareClass.ytdPercentage && this.props.fund.shareClass.ytdPercentage.ytdPercentage && (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'QUICK_STAT_YTD_WITH_SALES_CHARGE') || _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'QUICK_STAT_YTD_WITHOUT_SALES_CHARGE'))) {
        return _react2.default.createElement(
          'div',
          {
            className: 'col-xs-7 col-sm-6 ' + bootstrapColumns + ' margin-horizontal-0 ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "padding-top-15", "padding-top-30 left-border") + ' ' + (this.props.breakpoint === 3 && !isMoneyMarketFund ? "margin-bottom-25" : "") },
          _react2.default.createElement(_ytd_percentage_us2.default, {
            ytdPercentage: this.props.fund.shareClass.ytdPercentage.ytdPercentage,
            ytdDate: this.props.fund.shareClass.ytdPercentage.ytdDate,
            salesChargeAdjustedYtdPercentage: this.props.fund.shareClass.ytdPercentage.salesChargeAdjustedYtdPercentage,
            fundTypeCode: this.props.fund.fundTypeCode,
            breakpoint: this.props.breakpoint,
            disclosure: this.props.disclosures.pdpSummaryYtdPopUp,
            tooltip: this.props.tooltip,
            country: this.props.country,
            role: this.props.role,
            intl: this.props.intl
          })
        );
      } else if (this.props.fund.shareClass.performanceSummaryReturns && this.props.fund.shareClass.performanceSummaryReturns.length > 0 && _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'QUICK_STAT_YTD_AUUT')) {
        return _react2.default.createElement(
          'div',
          {
            className: 'col-xs-7 col-sm-6 ' + bootstrapColumns + ' margin-horizontal-0 ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "padding-top-15", "padding-top-30 left-border") + ' ' + (this.props.breakpoint === 3 && !isMoneyMarketFund ? "margin-bottom-25" : "") },
          _react2.default.createElement(_ytd_percentage_us2.default, {
            ytdPercentage: this.props.fund.shareClass.performanceSummaryReturns[0].ytd,
            ytdDate: this.props.fund.shareClass.performanceSummaryReturns[0].effectiveDate,
            fundTypeCode: this.props.fund.fundTypeCode,
            breakpoint: this.props.breakpoint,
            disclosure: this.props.disclosures.pdpSummaryYtdPopUp,
            tooltip: this.props.tooltip,
            country: this.props.country,
            role: this.props.role,
            intl: this.props.intl
          })
        );
      }
      return null;
    }
  }, {
    key: 'renderSecYield',
    value: function renderSecYield(bootstrapColumns, isMoneyMarketFund, isUsETF, addMarginBP3) {
      if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'QUICK_STAT_7DAY_SEC_YIELD') && this.props.fund.shareClass.secYield.sevenDayUnsubSecYield) {
        return _react2.default.createElement(
          'div',
          {
            className: 'print-width-auto xs-hidden col-xs-12 col-sm-6 ' + bootstrapColumns + ' margin-horizontal-0 ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "padding-top-15", "padding-top-30 left-border") + '  ' + addMarginBP3 + ' ' + (this.props.breakpoint === 3 && isMoneyMarketFund ? "margin-bottom-0" : "") },
          _react2.default.createElement(_sec_yield2.default, {
            shareclass: this.props.fund.shareClass,
            assetClass: this.props.fund.assetClass,
            visibleDataPoints: 'QUICK_STAT_7DAY_SEC_YIELD',
            role: this.props.role,
            country: this.props.country,
            breakpoint: this.props.breakpoint,
            intl: this.props.intl
          })
        );
      }
      if (_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'QUICK_STAT_30DAY_SEC_YIELD') && this.props.fund.shareClass.yieldMonthEnd.thirtyDayUnsubSecYield) {
        return _react2.default.createElement(
          'div',
          {
            className: 'xs-hidden col-xs-12 col-sm-6 ' + bootstrapColumns + ' margin-horizontal-0 margin-horizontal-0 ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "padding-top-15", "padding-top-30 left-border") + ' ' + addMarginBP3 + ' ' + (this.props.breakpoint === 3 && isUsETF ? "margin-bottom-0" : "") },
          _react2.default.createElement(_sec_yield2.default, {
            disclosure: this.props.disclosures.pdpSummary30DaySECYieldPopUp,
            tooltip: this.props.tooltip,
            shareclass: this.props.fund.shareClass,
            assetClass: this.props.fund.assetClass,
            visibleDataPoints: 'QUICK_STAT_30DAY_SEC_YIELD',
            role: this.props.role,
            country: this.props.country,
            breakpoint: this.props.breakpoint,
            intl: this.props.intl
          })
        );
      }
      return null;
    }
  }, {
    key: 'renderAnnualisedDistributionRate',
    value: function renderAnnualisedDistributionRate() {
      if (!_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'QUICK_STAT_ANNUALIZED_DISTRIBUTION_RATE')) {
        return null;
      }
      var recordDate = (0, _functional_utility.pathOrNull)(['shareClass', 'fundShareclassDividend', 'recordDate'], this.props.fund);
      var annualizedDividendYieldPercentage = (0, _functional_utility.pathOrNull)(['shareClass', 'fundShareclassDividend', 'annualizedDividendYieldPercentage'], this.props.fund);
      return this.renderQuickStat(_string_utility2.default.renderFormattedLabel("Annualized Distribution Rate", "pdp-quick-stat-annualised-distribution-rate"), recordDate, _number_utility2.default.formatToPercentWith2FixedDecimalsAfterMultiplyingBy100(annualizedDividendYieldPercentage), 'quick-stat-annualised-distribution-rate', false, 'QUICK_STAT_ANNUALIZED_DISTRIBUTION_RATE', 'pdpSummaryAnnualizedDistributionRatePopUp', '', !(0, _functional_utility.isNilOrEmpty)(annualizedDividendYieldPercentage), (0, _functional_utility.isNilOrEmpty)(annualizedDividendYieldPercentage), true);
    }
  }, {
    key: 'renderAnnualisedYeild',
    value: function renderAnnualisedYeild() {
      return !(0, _ramda.isNil)(this.props.fund.shareClass.fundShareclassDividend) && !(0, _ramda.isNil)(this.props.fund.shareClass.fundShareclassDividend.annualizedDividendYieldPercentage) && this.renderQuickStat(_string_utility2.default.renderFormattedLabel("ANNUALISED YIELD", "pdp-fund-stats-annualised-yield-label"), this.props.fund.shareClass.fundShareclassDividend.recordDate, _number_utility2.default.formatToPercentWith2FixedDecimals(this.props.fund.shareClass.fundShareclassDividend.annualizedDividendYieldPercentage), 'quick-stat-annualised-yield', false, 'QUICK_STAT_ANNUALISED_YIELD', null, 'col-xs-6 col-sm-6 col-md-5 col-lg-2 col-xlg-2');
    }
  }, {
    key: 'renderQuickStat',
    value: function renderQuickStat(label, date, value, dataTestId, hideForMobile, visibleDataPoint, disclosureId) {
      var overrideStyle = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
      var addSpacer = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;
      var suppressAsOfDate = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : false;
      var showWhenNoValue = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : false;

      var hasVisibleDataAndValidValues = _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, visibleDataPoint) && !(0, _ramda.isNil)(date) && !(0, _ramda.isNil)(value) && value !== '-';
      if (showWhenNoValue || hasVisibleDataAndValidValues) {
        var formattedVal = _react2.default.createElement(_formatted_number2.default, { value: value, numberFormat: this.props.fund.numberFormat });
        var showTime = false;
        var timeZone = null;
        var marginBottom = this.getMarginBottom();

        overrideStyle = overrideStyle === '' ? 'col-xs-6 col-sm-6 col-md-5 col-lg-3 col-xlg-3' : overrideStyle;

        return _react2.default.createElement(
          'div',
          { 'data-testid': dataTestId,
            id: dataTestId,
            className: (hideForMobile ? 'xs-hidden' : '') + ' ' + overrideStyle + ' margin-horizontal-0 ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "padding-top-15", "padding-top-30 left-border") + ' ' + marginBottom },
          _react2.default.createElement(_quick_stat2.default, {
            dataTestId: dataTestId,
            asOfDate: date,
            quickStatLabel: label,
            quickStatValue: formattedVal,
            disclosureId: disclosureId,
            disclosure: this.props.fund.disclosures,
            tooltip: this.props.tooltip,
            showTime: showTime,
            timeZone: timeZone,
            role: this.props.role,
            addSpacer: _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, "QUICK_STAT_ADD_SPACER") || addSpacer,
            breakpoint: this.props.breakpoint,
            suppressAsOfDate: suppressAsOfDate
          })
        );
      }
      return null;
    }
  }, {
    key: 'shouldRenderQuickStats',
    value: function shouldRenderQuickStats(visibleDataPoints) {
      if ((0, _functional_utility.isNilOrEmpty)(visibleDataPoints)) {
        return false;
      }
      return _collection_utility.CollectionUtility.filter(visibleDataPoints, function (data) {
        return data.includes("QUICK_STAT");
      }).length > 0;
    }
  }, {
    key: 'shouldRenderHeaderStatsDiv',
    value: function shouldRenderHeaderStatsDiv() {
      return this.shouldRenderQuickStats(this.props.visibleDataPoints);
    }
  }, {
    key: 'getMarginBottom',
    value: function getMarginBottom() {
      return this.props.breakpoint === 3 ? "margin-bottom-25" : "";
    }
  }, {
    key: 'render',
    value: function render() {
      var isMoneyMarketFund = this.props.fund.assetClass === "Money Market";
      var isUsETF = (0, _fund_utility.isUSEtfFund)(this.props.country, this.props.fund.fundTypeCode);
      var isAUETF = (0, _fund_utility.isAUEtfFund)(this.props.country, this.props.fund.fundTypeCode);
      var quickDataPointsLength = !(0, _ramda.isNil)(this.props.visibleDataPoint) ? this.props.visibleDataPoints.filter(function (quickStat) {
        return quickStat.startsWith('QUICK_STAT');
      }).length : 4;
      var bootstrapColumns = quickDataPointsLength <= 3 ? "col-md-5 col-lg-4 col-xlg-4" : "col-md-5 col-lg-3 col-xlg-3";
      var expensesAdditionalStyle = _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, "QUICK_STAT_MANAGEMENT_COSTS") && !isAUETF ? "col-md-5 col-lg-4 col-xlg-4 padding-right-0" : bootstrapColumns;
      var marginBottom = this.getMarginBottom();
      var quickStatsStyle = this.props.customHeaderStats ? "col-xs-12 col-sm-12" : "col-xs-6 col-sm-6";
      var quickStatNavLabelKey = (0, _fund_utility.isJPNonLiq)(this.props.country, this.props.role) ? "pdp-quick-stat-nav-label" : "pdp-fund-stats-nav-label";
      var shouldUseTranslatedMessageToFormatCurrency = _collection_utility.CollectionUtility.includes(this.props.formattingRules, 'CURRENCY_FORMATTED_WITH_TRANSLATED_MESSAGE');
      var extraWidth = _collection_utility.CollectionUtility.includes(this.props.formattingRules, 'QUICK_STAT_NAV_EXTRA_WIDTH');

      var sinceInceptionReturn = !(0, _functional_utility.isNilOrEmpty)(this.props.fund.shareClass.fundShareclassPerformanceReturnMonthEnd) ? this.props.fund.shareClass.fundShareclassPerformanceReturnMonthEnd.filter(function (item) {
        return item.returnPeriodIndicator === "INC";
      })[0] : null;

      var oneYrAnnualized = (0, _fund_utility.getOneYrAnnualized)(this.props.fund.shareClass.fundShareclassPerformanceReturnMonthEnd);
      var desktopBreakpointWidth = extraWidth ? '5' : '3';

      return this.shouldRenderHeaderStatsDiv() && _react2.default.createElement(
        'div',
        { 'data-testid': 'header-stats',
          id: 'header-stats',
          className: 'row ' + (this.props.breakpoint < 3 ? "" : "margin-bottom-40") + ' margin-horizontal-0 blue-border print-hide' },
        this.shouldRenderQuickStats(this.props.visibleDataPoints) && _react2.default.createElement(
          'div',
          { className: quickStatsStyle + ' col-md-12 col-lg-12 col-xlg-12 padding-left-0 quick-stats-header-mobile row' },
          (0, _ramda.or)(_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'QUICK_STAT_NAV_WITH_EST_TIMEZONE'), _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'QUICK_STAT_NAV_WITH_LOCAL_TIMEZONE')) && _react2.default.createElement(
            'div',
            { className: 'col-xs-5 col-sm-6 col-md-5 col-lg-' + desktopBreakpointWidth + ' col-xlg-' + desktopBreakpointWidth + ' margin-horizontal-0 ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "padding-top-15", "padding-top-30 left-border") + ' ' + marginBottom },
            _react2.default.createElement(_nav2.default, {
              label: _string_utility2.default.renderFormattedLabel("NAV", quickStatNavLabelKey, { fundType: this.props.fund.fundTypeCode }),
              dataTest: 'nav-test', nav: this.props.fund.shareClass.nav,
              currencyCode: this.props.fund.currencyCode, fundTypeCode: this.props.fund.fundTypeCode,
              assetClass: this.props.fund.assetClass,
              breakpoint: this.props.breakpoint,
              intraDayNav: this.props.fund.shareClass.intraDayNav, country: this.props.country,
              visibleDataPoints: this.props.visibleDataPoints,
              formattingRules: this.props.formattingRules,
              numberFormat: this.props.fund.numberFormat,
              role: this.props.role,
              navDecimalPoints: this.props.fund.shareClass.nav.navDecimalPoints,
              shareclassCurrencyCode: this.props.fund.shareClass.currencyCode,
              shouldUseTranslatedMessageToFormatCurrency: shouldUseTranslatedMessageToFormatCurrency,
              disclosure: (this.props.disclosures || {}).pdpDataPointNAV,
              tooltip: this.props.tooltip
            })
          ),
          !(0, _functional_utility.isNilOrEmpty)(sinceInceptionReturn) && _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'QUICK_STAT_SINCE_INCEPTION_RETURN') && _react2.default.createElement(
            'div',
            {
              className: 'col-xs-7 col-sm-6 ' + bootstrapColumns + ' margin-horizontal-0 ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "padding-top-15", "padding-top-30 left-border") + ' ' + (this.props.breakpoint === 3 && !isMoneyMarketFund ? "margin-bottom-25" : "") },
            _react2.default.createElement(_ytd_percentage_us2.default, {
              title: _string_utility2.default.renderFormattedLabel("Since Inception Return", "pdp-fund-stats-since-inception-return-label"),
              ytdPercentage: !(0, _ramda.isNil)(oneYrAnnualized) && !(0, _ramda.isNil)(oneYrAnnualized.annualizedNoLoadReturnPercentage) ? sinceInceptionReturn.annualizedNoLoadReturnPercentage : sinceInceptionReturn.cumulativeNoLoadPercentage,
              ytdDate: sinceInceptionReturn.performanceReturnEffectiveDate,
              salesChargeAdjustedYtdPercentage: !(0, _ramda.isNil)(oneYrAnnualized) && !(0, _ramda.isNil)(oneYrAnnualized.annualizedLoadPercentage) ? sinceInceptionReturn.annualizedLoadPercentage : sinceInceptionReturn.cumulativeLoadPercentage,
              fundTypeCode: this.props.fund.fundTypeCode,
              breakpoint: this.props.breakpoint,
              tooltip: this.props.tooltip,
              country: this.props.country,
              role: this.props.role,
              intl: this.props.intl
            })
          ),
          this.renderSinceInceptionReturnAtNav(sinceInceptionReturn, bootstrapColumns, isMoneyMarketFund),
          this.renderAnnualisedDistributionRate(),
          this.renderQuickStat(_string_utility2.default.renderFormattedLabel("NAV", "pdp-fund-stats-nav-label", { fundType: this.props.fund.fundTypeCode }), this.props.fund.shareClass.nav.date, _currency_utility2.default.convertToCurrencyForNav(this.props.fund.shareClass.nav.price, this.props.fund.shareClass.currencyCode, this.props.fund.fundTypeCode, this.props.country, this.props.fund.shareClass.nav.navDecimalPoints), 'quick-stat-nav', false, 'QUICK_STAT_NAV_SIMPLE_WITH_LOCAL_TIMEZONE', 'pdpSummaryNAV'),
          (0, _ramda.and)((0, _ramda.and)(!(0, _ramda.isNil)(this.props.fund.shareClass), !(0, _ramda.isNil)(this.props.fund.shareClass.nav)), !(0, _ramda.isNil)(this.props.fund.shareClass.nav.price)) && this.renderQuickStat('NAV', this.props.fund.shareClass.nav.navEffectiveDate, _currency_utility2.default.formatNumberForPenceWith2DecimalPlaces(this.props.fund.shareClass.nav.price), 'quick-stat-nav-pence', false, 'QUICK_STAT_NAV_WITH_PENCE', 'pdpSummaryNAV'),
          !(0, _ramda.isNil)(this.props.fund.shareClass.marketPrice) && !(0, _ramda.isNil)(this.props.fund.shareClass.marketPrice.amount) && this.renderQuickStat('MARKET PRICE', this.props.fund.shareClass.marketPrice.date, _currency_utility2.default.convertToCurrencyForNav(this.props.fund.shareClass.marketPrice.amount, this.props.currencyCode, this.props.fundTypeCode, this.props.country, this.props.navDecimalPoints), 'quick-stat-market-price', false, 'QUICK_STAT_MARKET_PRICE'),
          !(0, _ramda.isNil)(this.props.fund.shareClass.marketPrice.premiumDiscountPercentage) && this.renderQuickStat(_string_utility2.default.renderFormattedLabel("Discount / premium", "label-for-discount-prem"), this.props.fund.shareClass.nav.date, (0, _number_utility3.formatToPercentWith2FixedDecimals)(this.props.fund.shareClass.marketPrice.premiumDiscountPercentage), 'quick-stat-premium-discount-percentage', true, 'QUICK_STAT_PREMIUM_DISCOUNT_PERCENTAGE', 'pdpSummaryDiscountPremium'),
          !(0, _ramda.isNil)(this.props.fund.currentSharePrice) && !(0, _ramda.isNil)(this.props.fund.currentSharePrice.closingPrice) && this.renderQuickStat('Share price', this.props.fund.currentSharePriceDate, _currency_utility2.default.formatNumberForPenceWith2DecimalPlaces(this.props.fund.currentSharePrice.closingPrice), 'quick-stat-share-price', false, 'QUICK_STAT_SHARE_PRICE'),
          this.renderQuickStat('Quoted price', this.props.fund.shareClass.nav.date, parseFloat(this.props.fund.shareClass.nav.price).toFixed(2) + "p", 'quick-stat-nav', false, 'QUICK_STAT_QUOTED_PRICE', "pdpSummaryQuotedPrice"),
          this.renderYtdPercentageUS(bootstrapColumns, isMoneyMarketFund),
          !(0, _ramda.isNil)(this.props.fund.shareClass.calendarYearYTD) && !(0, _ramda.isNil)(this.props.fund.shareClass.calendarYearYTD.fundShareclassPerformance) && this.renderQuickStat(_string_utility2.default.renderFormattedLabel("YTD", "label-for-ytd"), this.props.fund.shareClass.calendarYearYTD.fundShareclassPerformance.performanceReturnEffectiveDate, _number_utility2.default.convertDecimalToPercentWith2FixedDecimals(this.props.fund.shareClass.calendarYearYTD.fundShareclassPerformance.cumulativeNoLoadPercentage), 'quick-stat-ytd', false, 'QUICK_STAT_YTD_SIMPLE', "pdpSummaryYtdPopUp"),
          this.renderSecYield(bootstrapColumns, isMoneyMarketFund, isUsETF, marginBottom),
          this.renderDailyYield(),
          this.renderTaxableEquivalentYield(),
          this.renderAnnualisedYeild(),
          _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'QUICK_STAT_SHARE_CLASS_EXPENSES') && (isAUETF || (0, _ramda.isNil)((this.props.fund.grossYieldToMaturity || {}).value) || (0, _ramda.isNil)(this.props.fund.shareClass.netYieldToMaturity)) && _react2.default.createElement(
            'div',
            { className: 'xs-hidden col-xs-12 col-sm-6 ' + expensesAdditionalStyle + ' margin-horizontal-0 ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "padding-top-15", "padding-top-30 left-border") + ' ' + marginBottom },
            _react2.default.createElement(_expenses2.default, {
              expenses: this.props.fund.shareClass.expenses,
              breakpoint: this.props.breakpoint,
              visibleDataPoints: this.props.visibleDataPoints })
          ),
          this.renderQuickStat(_string_utility2.default.renderFormattedLabel("1 Day current yield", "pdp-summary-header-one-day-current-yield-label"), this.props.fund.shareClass.secYield.effectiveDate, _number_utility2.default.formatToPercentWith2FixedDecimalsAfterMultiplyingBy100(this.props.fund.shareClass.secYield.oneDayCurrentYield), 'quick-stat-one-day-sec-yield', false, 'QUICK_STAT_1DAY_SEC_YIELD'),
          this.renderQuickStat(_string_utility2.default.renderFormattedLabel("Fund size", "pdp-fund-stats-total-fund-size-label", { role: this.props.role }), this.props.fund.aum.date, _currency_utility2.default.getFundSizeBasedOnRules((0, _ramda.pathOr)([], ["visibleData", "formattingRules"], this.props.fund), this.props.country, this.props.fund.aum.value, this.props.fund.currencyCode, this.props.fund.numberFormat, this.props.role), 'quick-stat-fund-size', true, 'QUICK_STAT_FUND_SIZE'),
          this.renderQuickStat(_string_utility2.default.renderFormattedLabel("Fund size", "pdp-fund-stats-total-fund-size-label", { role: this.props.role }), this.props.fund.aum.date, _currency_utility2.default.getFundSizeBasedOnRules((0, _ramda.pathOr)([], ["visibleData", "formattingRules"], this.props.fund), this.props.country, this.props.fund.aum.value, this.props.fund.currencyCode, this.props.fund.numberFormat, this.props.role), 'quick-stat-fund-size-published-aum', true, 'QUICK_STAT_PUBLISHED_AUM'),
          _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'QUICK_STAT_AUM') && _react2.default.createElement(
            'div',
            { className: 'xs-hidden col-xs-12 col-sm-6 ' + bootstrapColumns + ' margin-horizontal-0 ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "padding-top-15", "padding-top-30 left-border") + ' ' + marginBottom },
            _react2.default.createElement(_aum2.default, {
              aum: this.props.fund.aum,
              currencyCode: this.props.fund.currencyCode,
              fundTypeCode: this.props.fund.fundTypeCode,
              role: this.props.role
            })
          ),
          this.renderQuickStat(_string_utility2.default.renderFormattedLabel('Weekly liquid assets', "pdp-weekly-liquid-assets-label"), !(0, _ramda.isNil)(this.props.fund.liquidityValDate) ? this.props.fund.liquidityValDate : this.props.fund.fundValuationDate, _number_utility2.default.formatToPercentWith2FixedDecimalsAfterMultiplyingBy100(this.props.fund.liquidityWeeklyPercentage), 'quick-stat-liq-weekly', true, 'QUICK_STAT_LIQUIDITY_WEEKLY_ASSET_SIMPLE'),
          _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'QUICK_STAT_LIQUIDITY_WEEKLY_ASSET') && _react2.default.createElement(
            'div',
            { className: 'xs-hidden col-xs-12 col-sm-6 ' + bootstrapColumns + ' margin-horizontal-0 ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "padding-top-15", "padding-top-30 left-border") + ' ' + marginBottom },
            _react2.default.createElement(_weekly_liquid_asset2.default, {
              liquidityWeeklyPercentage: this.props.fund.liquidityWeeklyPercentage,
              asOfDate: this.props.fund.fundValuationDate,
              role: this.props.role
            })
          ),
          !(0, _ramda.isNil)(this.props.fund.bondYTM) && !_collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, "HIDE_YIELD_TO_MATURITY") && this.renderQuickStat(_string_utility2.default.renderFormattedLabel("Yield to maturity ({currencyCode})", "pdp-summary-header-yield-to-maturity-label", {
            "currencyCode": _currency_utility2.default.getCurrencyTranslation(this.props.fund.currencyCode)
          }), this.props.fund.bondQualityBreakdown.effectiveDate, _number_utility2.default.formatToPercentWithoutDecimalPoints(this.props.fund.bondYTM), 'quick-stat-bond-ytm', true, 'QUICK_STAT_BOND_YTM', "pdpSummaryYtmYtwPopUp"),
          !(0, _ramda.isNil)(this.props.fund.bondYTW) && this.renderQuickStat(_string_utility2.default.renderFormattedLabel("Yield to worst ({currencyCode})", "pdp-summary-header-yield-to-worst-label", {
            "currencyCode": _currency_utility2.default.getCurrencyTranslation(this.props.fund.currencyCode)
          }), this.props.fund.bondQualityBreakdown.effectiveDate, _number_utility2.default.formatToPercentWithoutDecimalPoints(this.props.fund.bondYTW), 'quick-stat-bond-ytw', true, 'QUICK_STAT_BOND_YTW', "pdpSummaryYtmYtwPopUp"),
          !(0, _ramda.isNil)(this.props.fund.shareClass.netGrossAssetClass) && this.renderQuickStat('Total assets', this.props.fund.shareClass.grossAssetClassEffectiveDate, _currency_utility2.default.convertToCurrencyIntoMillionsWithCurrencyCodeAndSuffix(this.props.fund.shareClass.netGrossAssetClass, 2, this.props.fund.currencyCode), 'quick-stat-gross-assets', true, 'QUICK_STAT_GROSS_ASSETS'),
          _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'QUICK_STAT_YIELD_TO_MATURITY') && !(0, _ramda.isNil)((this.props.fund.grossYieldToMaturity || {}).value) && !(0, _ramda.isNil)(this.props.fund.shareClass.netYieldToMaturity) && _react2.default.createElement(
            'div',
            {
              className: 'print-width-auto xs-hidden col-xs-12 col-sm-6 ' + bootstrapColumns + ' margin-horizontal-0 ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "padding-top-15", "padding-top-30 left-border") + '  ' + marginBottom + ' ' + (this.props.breakpoint === 3 && isMoneyMarketFund ? "margin-bottom-0" : "") },
            _react2.default.createElement(_yield_to_maturity_worst2.default, { breakpoint: this.props.breakpoint,
              role: this.props.role,
              title: _string_utility2.default.getLocalizedString(this.props.intl, "YIELD TO MATURITY", "label-for-yield-to-maturity"),
              tooltip: this.props.tooltip,
              tooltipId: "pdpSummaryYtmPopUp",
              labelPrefix: "ytm",
              disclosure: this.props.disclosures.pdpSummaryYtmPopUp,
              net: this.props.fund.shareClass.netYieldToMaturity,
              netEffectiveDate: this.props.fund.shareClass.netYieldToMaturityEffectiveDate,
              gross: this.props.fund.grossYieldToMaturity || {}
            })
          ),
          _collection_utility.CollectionUtility.includes(this.props.visibleDataPoints, 'QUICK_STAT_YIELD_TO_WORST') && !(0, _ramda.isNil)((this.props.fund.grossYieldToWorst || {}).value) && !(0, _ramda.isNil)(this.props.fund.shareClass.netYieldToWorst) && _react2.default.createElement(
            'div',
            {
              className: 'print-width-auto xs-hidden col-xs-12 col-sm-6 ' + bootstrapColumns + ' margin-horizontal-0 ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "padding-top-15", "padding-top-30 left-border") + '  ' + marginBottom + ' ' + (this.props.breakpoint === 3 && isMoneyMarketFund ? "margin-bottom-0" : "") },
            _react2.default.createElement(_yield_to_maturity_worst2.default, { breakpoint: this.props.breakpoint,
              role: this.props.role,
              title: _string_utility2.default.getLocalizedString(this.props.intl, "YIELD TO WORST", "label-for-yield-to-worst"),
              tooltip: this.props.tooltip,
              tooltipId: "pdpDataPointYieldToWorst",
              labelPrefix: "ytw",
              disclosure: this.props.disclosures.pdpDataPointYieldToWorst,
              net: this.props.fund.shareClass.netYieldToWorst,
              gross: this.props.fund.grossYieldToWorst || {}
            })
          )
        )
      );
    }
  }]);

  return HeaderStats;
}(_react2.default.Component);

exports.default = HeaderStats;